const $ = require('jquery');
const _ = require('lodash');

/*
NOTE:

On localhost, ZoomInfo will run in development mode.
In development mode, following emails can be used to test the form:
- no-match@zoominfo.com
- partial-match@zoominfo.com
- full-match@zoominfo.com

To initialize ZoomInfo on the page use the snippet from the ZoomInfo dashboard.
 */

module.exports = class ZoomInfo {
	constructor (
		zoomInfoFormId,
		formName,
		formSelector,
		emailInputSelector,
		autofillFieldSelectors,
		loggerFactory,
		inputWrapperClass = 'itbl-b-form__input-wrap'
	) {
		this.zoomInfoFormId = zoomInfoFormId;
		this.formName = formName;
		this.formSelector = formSelector;
		this.emailInputSelector = emailInputSelector;
		this.autofillFieldSelectors = autofillFieldSelectors;
		this.inputWrapperClass = inputWrapperClass;
		this.logger = loggerFactory.getLogger('ZoomInfo');
		ZoomInfo.formcompleteInitialized = false;

		this.zoomInfoReady = false;

		this.load();
	}

	load () {
		this.addFormName();
		this.listenToEmailInputBlur();
		this.hideAutofillFields();
	}

	hideAutofillFields () {
		_.map(this.autofillFieldSelectors, (selector) => {
			$(selector)
				.closest(`.${this.inputWrapperClass}`)
				.addClass('hidden');
		});
	}

	showAutofillFields () {
		_.map(this.autofillFieldSelectors, (selector) => {
			$(selector)
				.closest(`.${this.inputWrapperClass}`)
				.removeClass('hidden');
		});
	}

	showEmptyAutofillFields () {
		_.map(this.autofillFieldSelectors, (selector) => {
			const $field = $(selector);
			if (_.isEmpty($field.val())) {
				const wrapperSelector = `.${this.inputWrapperClass}`;

				const $parent = $field.closest(wrapperSelector);

				$parent.removeClass('hidden');

				$field.attr("data-hasusertyped", "true");
			}
		});
	}

	showNotEnrichedFields () {
		const $fields = $('[data-zi-field-enriched="false"]');
		$fields.removeClass('hidden');

		// NOTE:
		// data-hasusertyped is not described in the documentation.
		// Type into a field and then inspect formcomplete.js to figure it out.
		// Prevents creepy autofill when field visible.
		$('[data-zi-input-enriched="false"]').attr("data-hasusertyped", "true");
	}

	getForm () {
		return $(this.formSelector);
	}

	addFormName () {
		this.getForm().attr("data-formname", this.formName);
	}

	getEmailInput () {
		return $(this.emailInputSelector);
	}

	listenToEmailInputBlur () {
		this.getEmailInput().on('change', () => {
			setTimeout(() => {
				this.showEmptyAutofillFields();
			}, 1000);
		});
	}

	getCallbacks () {
		const self = this;

		return {
			onReady: function () {
				self.zoomInfoReady = true;
			}
		};
	}
}